import React from 'react';

interface LoadingProps {
  text?: string;
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ text = 'Loading...', fullScreen = false }) => {
  const className = fullScreen ? 'center' : 'loading';
  
  return (
    <div className={className}>
      <div className="spinner"></div>
      <span>{text}</span>
    </div>
  );
};

export default Loading;